/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

/**
 * Generates a random ID.
 * @param {number} length
 * @return {string}
 */
export function randomId (length = 8) {
  const dict = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let out = ''
  for (let i = 0; i < length; i += 1) {
    out += dict[Math.round(Math.random() * (dict.length - 1))]
  }
  return out
}
